// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ck.ck-heading_heading1{\n  font-size:20px\n}\n\n.ck.ck-heading_heading2{\n  font-size:17px\n}\n\n.ck.ck-heading_heading3{\n  font-size:14px\n}\n\n.ck[class*=ck-heading_heading]{\n  font-weight:700\n}\n\n.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__button .ck-button__label{\n  width:8em\n}\n\n.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__panel .ck-list__item{\n  min-width:18em\n}", ""]);
// Exports
module.exports = exports;
